/*
  Guia de uso — construtor de ritual.
  Os dados técnicos do produto (tempos de pausa, temperatura e passadas
  por tipo de cabelo) vivem nas constantes TIPOS / OBS / OBS_SENS abaixo.
  Para alterá-los, edite este arquivo; o conteúdo editorial (nomes,
  descrições, labels) é editável pelo customizador do tema.
*/
if (!customElements.get('usage-guide-builder')) {
  const TIPOS = {
    finos: { rotulo: 'finos', pausaRe: '30 a 40', pausaAl: '50 a 60', temp: '180', passadas: '10 a 12' },
    medios: { rotulo: 'médios', pausaRe: '40 a 50', pausaAl: '60 a 75', temp: '200 a 210', passadas: '12 a 15' },
    grossos: { rotulo: 'grossos ou resistentes', pausaRe: '50 a 60', pausaAl: '75 a 90', temp: 'até 230', passadas: '15 a 20' },
  };

  const OBS = {
    sempausa:
      'O Livre Sem Pausa mantém sempre 10 minutos, em qualquer tipo de fio. É o tempo do dia a dia: controla o frizz e devolve movimento sem alterar o desenho natural.',
    realinhamento: 'Fios TIPO pedem essa pausa para alinhar sem perder o corpo natural do cabelo.',
    alisamento:
      'Fios TIPO pedem a pausa mais longa para a máxima redução de volume. Se for a sua primeira vez, comece pelo tempo mínimo da faixa.',
  };

  const OBS_SENS =
    'Cabelos loiros, descoloridos ou sensibilizados pedem cuidado redobrado: nunca ultrapasse 180 °C e trabalhe com menos passadas por mecha.';

  class UsageGuideBuilder extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const { signal } = this.abort;

      this.elPausa = this.querySelector('[data-ug="pausa"]');
      this.elTemp = this.querySelector('[data-ug="temp"]');
      this.elPass = this.querySelector('[data-ug="passadas"]');
      this.elObs = this.querySelector('[data-ug="obs"]');
      this.saida = this.querySelector('[data-ug="saida"]');

      const tipoInicial = this.querySelector('[data-ug="tipos"] [aria-pressed="true"]');
      const modoInicial = this.querySelector('[data-ug="resultados"] [aria-pressed="true"]');
      const primeiroModo = this.querySelector('[data-ug="resultados"] [data-modo]');

      this.estado = {
        tipo: tipoInicial ? tipoInicial.dataset.tipo : 'medios',
        modo: modoInicial ? modoInicial.dataset.modo : primeiroModo ? primeiroModo.dataset.modo : 'realinhamento',
        sens: false,
      };

      this.ligar('[data-ug="tipos"] [data-tipo]', 'tipo', 'tipo', signal);
      this.ligar('[data-ug="resultados"] [data-modo]', 'modo', 'modo', signal);

      const sens = this.querySelector('[data-ug="sens"]');
      if (sens) {
        sens.addEventListener(
          'change',
          (e) => {
            this.estado.sens = e.target.checked;
            this.pintar();
          },
          { signal }
        );
      }

      this.pintar();
      this.centralizar(modoInicial, false);
    }

    // No mobile os cards de resultado são um trilho com scroll lateral: traz o
    // card escolhido para o centro. Rola só o trilho, nunca a página.
    centralizar(card, suave) {
      const trilho = card?.closest('[data-ug="resultados"]');
      if (!trilho || trilho.scrollWidth <= trilho.clientWidth) return;

      const delta = card.getBoundingClientRect().left - trilho.getBoundingClientRect().left;
      const left = trilho.scrollLeft + delta - (trilho.clientWidth - card.offsetWidth) / 2;
      const calmo = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      trilho.scrollTo({ left, behavior: suave && !calmo ? 'smooth' : 'auto' });
    }

    disconnectedCallback() {
      this.abort?.abort();
    }

    ligar(seletor, chave, atributo, signal) {
      const botoes = this.querySelectorAll(seletor);
      botoes.forEach((b) => {
        b.addEventListener(
          'click',
          () => {
            botoes.forEach((o) => o.setAttribute('aria-pressed', 'false'));
            b.setAttribute('aria-pressed', 'true');
            this.estado[chave] = b.dataset[atributo];
            this.pintar();
            if (chave === 'modo') this.centralizar(b, true);
          },
          { signal }
        );
      });
    }

    pintar() {
      const t = TIPOS[this.estado.tipo] || TIPOS.medios;
      let modo = this.estado.modo;
      if (!OBS[modo]) modo = 'realinhamento';

      let pausa;
      if (modo === 'sempausa') pausa = '10';
      else if (modo === 'realinhamento') pausa = t.pausaRe;
      else pausa = t.pausaAl;

      let temp, passadas, obs;
      if (this.estado.sens) {
        temp = '180';
        passadas = '8 a 10';
        obs = OBS_SENS;
      } else {
        temp = t.temp;
        passadas = t.passadas;
        obs = OBS[modo].replace('TIPO', t.rotulo);
      }

      if (this.elPausa) this.elPausa.innerHTML = pausa + ' <small>min</small>';
      if (this.elTemp) this.elTemp.innerHTML = temp + ' <small>°C</small>';
      if (this.elPass) this.elPass.textContent = passadas;
      if (this.elObs) this.elObs.textContent = obs;

      this.pintarTokens({ pausa, temp, passadas });

      if (this.saida) {
        this.saida.classList.remove('ug-fade');
        void this.saida.offsetWidth;
        this.saida.classList.add('ug-fade');
      }
    }

    // Reflete as escolhas no texto do modo de uso (pills {pausa}, {temperatura},
    // {passadas} e {modo}), que fica fora deste elemento, na mesma section.
    pintarTokens({ pausa, temp, passadas }) {
      const escopo = this.closest('.usage-guide');
      if (!escopo) return;

      const cardAtivo = this.querySelector('[data-ug="resultados"] [aria-pressed="true"]');
      const nomeModo = cardAtivo?.querySelector('.usage-guide__card-name')?.textContent.trim();

      const valores = {
        pausa: pausa + ' min',
        temperatura: temp + ' °C',
        passadas: passadas,
        modo: nomeModo,
      };

      Object.entries(valores).forEach(([chave, valor]) => {
        if (!valor) return;
        escopo.querySelectorAll('[data-ug-token="' + chave + '"]').forEach((el) => {
          if (el.textContent === valor) return;
          el.textContent = valor;
          el.classList.remove('ug-fade');
          void el.offsetWidth;
          el.classList.add('ug-fade');
        });
      });
    }
  }

  customElements.define('usage-guide-builder', UsageGuideBuilder);
}

/*
  Vídeos do passo a passo (data-livre-autoplay): mudos, em loop, com preload none.
  Só baixam e tocam quando o passo entra na tela e pausam ao sair.
  Com reduced-motion, fica só a capa.
*/
if (!window.livreStepVideos) {
  window.livreStepVideos = true;

  const reduzMovimento = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observer =
    'IntersectionObserver' in window &&
    new IntersectionObserver(
      (entries) => {
        entries.forEach(({ target: video, isIntersecting }) => {
          if (isIntersecting && !reduzMovimento.matches) {
            video.muted = true;
            const p = video.play();
            if (p !== undefined) p.catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.5 }
    );

  const observar = (raiz) => {
    if (!observer) return;
    raiz.querySelectorAll('[data-livre-autoplay] > video').forEach((video) => observer.observe(video));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => observar(document));
  } else {
    observar(document);
  }
  document.addEventListener('shopify:section:load', (event) => observar(event.target));
}
